export interface AmountFieldTheme {
  inputField: string;
  red: string;
  green: string;
  black: string;
  white: string;
  primary: string;
  secondary: string;
  error: string;
  amountadornment: string;
  calcTooltip: string;
  calcTooltipContent: string;
  calcTooltipOperatorColumn: string;
  calcTooltipNumberColumn: string;
  calcTooltipOperandRow: string;
  calcTooltipOperatorRow: string;
  calcTooltipOperatorBadge: string;
  calcTooltipOperandValue: string;
  calcPlaceholderInput: string;
  calculatorAdornmentIcon: string;
}

export const amountFieldStyles = ({ palette, shape, shadows }) => ({
  inputField: {
    fontWeight: 400,
    whiteSpace: 'nowrap',
    textAlign: 'right',
  },
  calcPlaceholderInput: {
    paddingRight: 4,
  },
  calculatorAdornmentIcon: {
    width: 16,
    height: 16,
    display: 'block',
    color: palette.text.secondary,
  },
  calcTooltip: {
    background: palette.surface.page,
    borderRadius: shape.borderRadius * 2,
    boxShadow: `${shadows[8]}, 0px 4px 8px ${palette.background.layer1}`,
    padding: 0,
    maxWidth: 'none',
  },
  calcTooltipContent: {
    display: 'grid',
    gridTemplateColumns: '36px minmax(140px, 1fr)',
    minWidth: 200,
    overflow: 'hidden',
    borderRadius: shape.borderRadius,
  },
  calcTooltipOperatorColumn: {
    gridColumn: 1,
    gridRow: '1 / span 2',
    background: palette.surface.brandSubtle,
  },
  calcTooltipNumberColumn: {
    gridColumn: 2,
    gridRow: '1 / span 2',
    display: 'grid',
    gridTemplateRows: 'repeat(2, auto)',
    rowGap: 6,
    padding: '8px 12px',
  },
  calcTooltipOperandRow: {
    gridRow: 1,
    textAlign: 'right',
    fontSize: 14,
    color: palette.text.primary,
  },
  calcTooltipOperatorRow: {
    gridColumn: 1,
    gridRow: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  calcTooltipOperatorBadge: {
    boxSizing: 'border-box',
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    borderRadius: shape.shapesRadius.rounded,
    color: `${palette.primary.main} !important`,
    fontSize: '1.2rem !important',
  },
  calcTooltipOperandValue: {
    gridRow: 2,
    fontSize: 14,
    color: palette.text.primary,
    height: '24px',
    textAlign: 'right',
  },
  red: {
    color: `${palette.amount.negative} !important`,
    whiteSpace: 'nowrap',
  },
  green: {
    color: `${palette.amount.positive} !important`,
    whiteSpace: 'nowrap',
  },
  black: {
    color: `${palette.text.strong} !important`,
    whiteSpace: 'nowrap',
  },
  white: {
    color: palette.text.contrastText,
    whiteSpace: 'nowrap',
  },
  primary: {
    color: palette.primary.main,
    whiteSpace: 'nowrap',
  },
  secondary: {
    color: palette.secondary.main,
    whiteSpace: 'nowrap',
  },
  error: {
    color: palette.primary.error,
    whiteSpace: 'nowrap',
  },
  amountadornment: {
    marginLeft: 0,
    marginRight: 4,
  },
});

export const amountSpanStyle = ({ palette, applyOpacityToHex }) => {
  const root = {
    color: `${palette.text.strong} !important`,
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 3,
    verticalAlign: 'middle',
    border: '1px solid transparent',
  };
  return ({
    root,
    normal: {
      ...root,
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: applyOpacityToHex(palette.text.strong, 0.1),
      },
    },
    focused: {
      letterSpacing: '0.4px',
      ...root,
      border: `1px solid ${applyOpacityToHex(palette.primary.main, 0.6)}`,
      backgroundColor: palette.background.paper,
    },
    editSpan: {
      outlineWidth: 0,
      outlineStyle: 'none',
      minWidth: 4,
      padding: 3,
      paddingRight: 5,
    },
    underlineFocused: {
      letterSpacing: '0.4px',
      ...root,
      border: `1px solid ${applyOpacityToHex(palette.primary.main, 0.6)}`,
      backgroundColor: palette.background.paper,
      borderRadius: 0,
      borderTopWidth: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0,
    },
  });
};
